var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import createPersistedState from 'use-persisted-state';
import { useCookieBanner } from './use-cookie-banner';
var usePersistedState = createPersistedState('cookieLevel');
export var useCookieLevel = function () {
  // back compat
  var _a = __read(useCookieBanner(), 1),
    agrees = _a[0];
  return usePersistedState(agrees ? 'accept' : 'unknown');
};